export enum EndUserLicenseAgreementStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}
